<template>
  <v-col cols="12" class="card card-front zoom-card">
    <v-row class="section-image">
      <v-img
        class="image-card"
        v-bind:src="url_logo"
        height="179px"
        cover
      >
      </v-img>
    </v-row>

    <v-row class="section-title-gallery">
      <p class="section-text-gallery">
        {{ data.title }}
      </p>
    </v-row>

    <v-row class="section-stand">
      <v-btn
        v-if="data.published==1 && data.published_by_admin==1"
        color="green"
        small
        :to="{ name: 'showWindowAdmin', params: { entrepreneurship_id: data.id } }"
      >
        Ver Stand
      </v-btn>

      <v-btn
        v-if="data.published==0 && data.published_by_admin==1"
        color="warning"
        small
        :to="{ name: 'showWindowAdmin', params: { entrepreneurship_id: data.id } }"
      >
        Ver Stand
      </v-btn>

      <v-btn
        v-if="data.published_by_admin==0"
        color="error"
        small
        :to="{ name: 'showWindowAdmin', params: { entrepreneurship_id: data.id } }"
      >
        Ver Stand
      </v-btn>
    </v-row>

    <v-row class="section-social">
      <v-btn
        icon
        large 
        color="red"
      >
        <v-icon>mdi-heart</v-icon>
      </v-btn>
      <label><small>{{ data.likes }}</small></label>
    </v-row>
  </v-col>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardProyectGalleryAdmin',
    props:['data'],

    data: () => ({
      show_card:false,
      loading:false,
      loading_btn: false,

      url_logo:null,
      base_url: null
    }),

    methods:{    
      createURL(){
        this.url_logo = this.base_url + this.data.logo
        this.show_card = true
      },

      truncate(str, length) {
        if (str.length > length) {
          return str.slice(0, length) + '...';
        } else return str;
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
.zoom-card {
  transition: transform .2s; /* Animation */
}

.zoom-card:hover {
  transform: scale(1.03); /* (20% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.card {
  width: 240px!important;
  height: 328px;
  background-color: #ffffff;
  border-radius: 8px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
}

.img-flag{
  height: auto;
  max-width: 30px;
}
.section-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  border-bottom: 1px solid rgb(0 0 0 / 0.2);
}

.image-card {
  border-top-right-radius: 8px 8px;
  border-top-left-radius: 8px 8px;
}

.section-title-gallery {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 4px 4px 4px;
}

.section-text-gallery {
  /* Configuración para limitar a 2 líneas con truncado */
  display: -webkit-box; /* Flexbox para WebKit */
  -webkit-box-orient: vertical; 
  -webkit-line-clamp: 2; /* Limita a 2 líneas */
  line-clamp: 2;
  overflow: hidden; /* Oculta el texto adicional */

  /* Asegura que los puntos suspensivos se muestren */
  text-overflow: ellipsis; 
  white-space: normal; /* Permite el salto de línea */

  /* Ajustes de espaciado entre líneas */
  line-height: 1.3em; 
  max-height: 3.2em; /* Altura máxima para 2 líneas */
}

.section-stand {
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  height: 46px;
}

.section-social {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
}
</style>